import styled from 'styled-components/macro';
import { blue1, baseBackground, lightGray7 } from 'components/common/colorConstants';

export const ThumbnailBtn = styled.button`
  cursor: pointer;
  width: 100px;
  height: 74px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid ${baseBackground};
  background: ${baseBackground};
  margin: 0;
  padding: 3px;
  outline: 0;
  transition: border 0.3s ease;
  touch-action: manipulation;
  overflow: hidden;

  &.selected {
    border-color: ${blue1};
  }

  &.small {
    width: 60px;
    height: 44px;
  }

  &.zoom-in {
    cursor: zoom-in;
  }

  .block-context {
    width: 100%;
    height: 100%;
  }

  .thumbnail {
    background: ${lightGray7};
    border: 0;
    border-radius: 2px;
    object-fit: cover;
    width: 100%;
    height: 100%;
    padding: 0;
  }
`;
